import { lazy } from 'react';
import { FuseRouteItemType } from '@fuse/utils/FuseUtils';

const PartnerAdminUsersPage = lazy(() => import('./users/PartnerAdminUsersPage'));
const PartnerAdminDashboardPage = lazy(() => import('./dashboard/PartnerAdminDashboardPage'));
const PartnerAdminReportsPage = lazy(() => import('./reports/PartnerAdminReportsPage'));
const PartnerAdminLocationsPage = lazy(() => import('./locations/PartnerAdminLocationsPage'));
const PartnerAdminEquipmentRentalsPage = lazy(() => import('./equipment-rentals/PartnerAdminEquipmentRentalsPage'));
const PartnerAdminStrandedItemsPage = lazy(() => import('./stranded-items/PartnerAdminStrandedItemsPage'));
const PartnerAdminScanView = lazy(() => import('./scan/PartnerAdminScanView'));

/**
 * PartnerAdmin self-service routes. Visible only to users carrying the PartnerAdmin role.
 */
const partnerAdminRoutes: FuseRouteItemType[] = [
	{
		path: 'partner-admin',
		auth: ['PartnerAdmin'],
		children: [
			{
				path: 'scan',
				element: <PartnerAdminScanView />
			},
			{
				path: 'users',
				element: <PartnerAdminUsersPage />
			},
			{
				path: 'dashboard',
				element: <PartnerAdminDashboardPage />
			},
			{
				path: 'reports',
				element: <PartnerAdminReportsPage />
			},
			{
				path: 'locations',
				element: <PartnerAdminLocationsPage />
			},
			{
				path: 'equipment-rentals',
				element: <PartnerAdminEquipmentRentalsPage />
			},
			{
				path: 'stranded-items',
				element: <PartnerAdminStrandedItemsPage />
			}
		]
	}
];

export default partnerAdminRoutes;
